var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Header',{on:{"open":function($event){return _vm.open()}}}),_c('v-main',[_c('router-view'),_c('Drawer',{attrs:{"showDrawer":_vm.showDrawer},on:{"close":function($event){return _vm.close()}}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }